<template>
  <div>
    <div class="mrB20" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_PORTL_ID')"
            :required="true"
          />
        </div>
        <div class="col-xs-5 ">
          <sui-input-label
            v-if="!isNew"
            ref="labelPortalId"
            :class="!isNew ? 'comm_label' : 'comm_label_1'"
            :label="objPortal.portalId"
            :vertical="false"
          />
          <sui-text-field
            v-if="isNew"
            ref="textFieldPortalId"
            v-model="objPortal.portalId"
            maxlength="100"
            @keyup="inputValid"
            @blur="inputValid"
            pattern="[A-Z0-9]"
          />
          <div class="comp_spacing" />
          <sui-button
            v-if="isNew"
            type="button"
            class="comm_btn_duplicate"
            @click="onClickDuplicationCheck"
          />
        </div>
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_PORTL_NM')"
            :required="true"
          />
        </div>
        <div class="col-xs-5 ">
          <sui-text-field
            ref="textFieldPortalName"
            v-model="objPortal.portalName"
            maxlength="100"
            :trim="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_USE_YN')"
            :required="true"
          />
        </div>
        <div class="col-xs-5 ">
          <sui-radio
            v-model="objPortal.useYn"
            value="Y"
          >
            {{ 'Yes' }}
          </sui-radio>
          <sui-radio
            v-model="objPortal.useYn"
            value="N"
          >
            {{ 'No' }}
          </sui-radio>
        </div>
        <div
          v-if="deviceApplyYn"
          class="col-xs-1 "
        >
          <sui-input-label
            :label="$t('MSG_TXT_DVC_TYPE')"
          />
        </div>
        <div
          v-if="deviceApplyYn"
          class="col-xs-5 "
        >
          <sui-device-checkbox
            ref="deviceCheck"
            :value="objPortal.deviceTypeValue"
          />
        </div>
        <div
          v-if="!deviceApplyYn"
          class="col-xs-1 nodata"
        />
        <div
          v-if="!deviceApplyYn"
          class="col-xs-5 nodata"
        />
      </div>
      <div class="row">
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_PORTL_CNTN')"
          />
        </div>
        <div class="col-xs-11 ">
          <sui-text-field
            ref="textFieldPortalContent"
            v-model="objPortal.portalContent"
            maxlength="1000"
            :trim="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_RGST_USR')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <cmp-user-name-link
            v-if="!isNew"
            :pageId="this.contextPageId"
            :displayType="'1'"
            :displayLanguageId="objPortal.firstRegistrationDisplayLanguageId"
            :userId="objPortal.firstRegistrationUserId"
            :loginId="objPortal.firstRegistrationLoginId"
            :knoxId="objPortal.firstRegistrationKnoxId"
            :userName="objPortal.firstRegistrationUserName"
            :userGlobalName="objPortal.firstRegistrationUserGlobalName"
            :departmentName="objPortal.firstRegistrationDepartmentName"
            :departmentEnglishName="objPortal.firstRegistrationDepartmentEnglishName"
            :type="'link'"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_RGST_DTM')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <div
            v-if="!isNew"
            class="comm_label">
            {{ objPortal.firstRegistrationDTM | dateFormat  }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_MDFC_USR')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <cmp-user-name-link
            v-if="!isNew"
            :pageId="this.contextPageId"
            :displayType="'1'"
            :displayLanguageId="objPortal.finalModificationDisplayLanguageId"
            :userId="objPortal.finalModificationUserId"
            :loginId="objPortal.finalModificationLoginId"
            :knoxId="objPortal.finalModificationKnoxId"
            :userName="objPortal.finalModificationUserName"
            :userGlobalName="objPortal.finalModificationUserGlobalName"
            :departmentName="objPortal.finalModificationDepartmentName"
            :departmentEnglishName="objPortal.finalModificationDepartmentEnglishName"
            :type="'link'"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_MDFC_DTM')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <div
            v-if="!isNew"
            class="comm_label">
            {{ objPortal.finalModificationDTM | dateFormat  }}
          </div>
        </div>
      </div>
    </div>
    <div class="mrB30" />
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:create="contextPageId"
        type="button"
        class="comm_btn_border"
        @click="onRestoreClick"
      >
        {{ $t('MSG_BTN_RESTORE') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickNew"
      >
        {{ $t("MSG_BTN_NEW") }}
      </sui-button>
      <sui-button
        v-permission:delete="contextPageId"
        type="button"
        class="comm_btn_border"
        @click="onClickDelete"
      >
        {{ $t("MSG_BTN_DEL") }}
      </sui-button>
      <sui-button
        v-permission:create="contextPageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>
    </div>
  </div>
</template>

<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMP_00025_T01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    selectedGridRowData: {
      type: Object,
      required: false,
    },
    deviceApplyYn: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    dateFormat(date) {
      if (!date) return '';
      return utils.dateformatToClient(date);
    },
  },
  data() {
    return {
      isNew : true,
      isIdDuplicationCheck: false,
      cachePortalId: '',
      selectedCodeValue:{
        COD_DVC_TYPE:{
          key: '',
          label: '',
        }
      },
      objPortal: {
        tenantId:this.$store.getters.userInfo.tenantId,
        portalId: '',
        portalName: '',
        portalContent: '',
        deviceTypeValue: 0,
        useYn: 'Y',
        deleteYn: '',
        firstRegistrationDTM: '',
        firstRegistrationUserId: '',
        firstRegistrationProgramId: '',
        finalModificationDTM: '',
        finalModificationUserId: '',
        finalModificationProgramId: '',
        firstRegistrationLoginId: '',
        firstRegistrationKnoxId: '',
        firstRegistrationUserName: '',
        firstRegistrationUserGlobalName: '',
        firstRegistrationDepartmentName: '',
        firstRegistrationDepartmentEnglishName: '',
        firstRegistrationDisplayLanguageId: '',
        finalModificationLoginId: '',
        finalModificationKnoxId: '',
        finalModificationUserName: '',
        finalModificationUserGlobalName: '',
        finalModificationDepartmentName: '',
        finalModificationDepartmentEnglishName: '',
        finalModificationDisplayLanguageId: '',
      },
    };
  },
  computed: {},
  watch: {
    selectedGridRowData(selectObj) {
      if (!utils.isEmpty(selectObj)) {
        this.loadPortal();
      } else {
        this.resetTab();
      }
    } 
  },
  created() {
    this.customOptions = {
    };
  },
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadPortal() {
      if(this.selectedGridRowData) {
        const portalId = this.selectedGridRowData.portalId;
        const tenantId = this.selectedGridRowData.tenantId;
        const dataParams = {
          tenantId: tenantId,
        }
        if(!utils.isEmpty(portalId)) {
          http.request(this.contextPageId, 'DTS_CMP_00103', {
            path: {
              'portal-id': portalId,
            },
            query: dataParams,
          }).then(res => {
            this.objPortal = res.data;
            this.isNew = false;
            this.isIdDuplicationCheck = true;
            if(this.deviceApplyYn) {
              this.$refs.deviceCheck.setValue(this.objPortal.deviceTypeValue);
            }
          });
        }
      }
    },
    onRestoreClick() {
      if (!this.objPortal.portalId) {
        // utils.messageBox('information', this.$t('MSG_ALT_NOT_SEL_ITEM'));
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
      } else if (this.objPortal.deleteYn === 'N') {
        utils.messageBox('information', this.$t('MSG_ALT_IMPOSSIBLE_RESTORE')); // 삭제하지 않는 데이터는 복원할 수 없습니다.
      } else {
        utils.messageBox('confirm', this.$t('MSG_ALT_IS_RESTORE_DATA'), null,
          (/* ok */) => {
            const tenantId = this.selectedGridRowData.tenantId;
            const dataParams = {
              tenantId: tenantId,
            }
            http.request(this.contextPageId, 'DTS_CMP_00132', {
              path: {
                'portal-id': this.objPortal.portalId,
              },
              query: dataParams,
            }).then(() => {
              utils.messageBox('success', this.$t('MSG_ALT_RESTORE_DATA'), null, () => {
                this.onClickNew();
                this.$emit('onClickSearch');
                // this.onClickSearch();
              });
            }).catch(error => {
              console.log(error);
            });
          },
          (/* cancel */) => {});
      }
    },
    resetTab() {
      this.objPortal.tenantId = this.objPortal.tenantId;
      this.objPortal.portalId = '';
      this.objPortal.portalName = '';
      this.objPortal.portalContent = '';
      this.objPortal.useYn = 'Y';
      this.objPortal.deviceTypeValue = 0;

      if(this.deviceApplyYn) {
        this.$refs.deviceCheck.setValue(0);
      }

      this.isNew = true;
      this.isIdDuplicationCheck = false;
    },
    onClickNew() {
      this.resetTab();
      this.$emit('onGridClear');
    },
    onClickDelete() {
      const portalId = this.objPortal.portalId;
      const dataParams = {
        tenantId : this.objPortal.tenantId
      }
      if(!utils.isEmpty(portalId) && this.objPortal.deleteYn === 'N') {
        utils.messageBox('confirm', this.$t('MSG_ALT_WANT_DEL'), null, () => {
          http.request(this.contextPageId, 'DTS_CMP_00106', {
            path: {
              'portal-id': portalId,
            },
            query: dataParams,
          }).then(() => {
            utils.messageBox('success', this.$t('MSG_ALT_DELETED'));
            this.$emit('onClickSearch');
            this.onClickNew();
          });
        });
      } else if (!utils.isEmpty(portalId) && this.objPortal.deleteYn === 'Y') {
        utils.messageBox('warning', this.$t('MSG_ALT_ALREADY_DELETE')); // 이미 삭제된 데이터입니다.
      } else {
        // utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onClickSave() {
      if (utils.isEmpty(this.objPortal.portalId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PORTL_ID')), null, () => {
          this.$refs.textFieldPortalId.setFocus();
        });
        return false;
      }
      if (utils.isEmpty(this.objPortal.portalName)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PORTL_NM')), null, () => {
          this.$refs.textFieldPortalName.setFocus();
        });
        return false;
      }

      if (!this.isIdDuplicationCheck || (this.isNew&&this.objPortal.portalId !== this.cachePortalId)) { // 중복 체크
        this.isIdDuplicationCheck = false;
        const msg = this.$t('MSG_ALT_SELT_DPCT_CHK');
        utils.messageBox('warning', msg);

        return false;
      }

      if(this.deviceApplyYn) {
        this.objPortal.deviceTypeValue = this.$refs.deviceCheck.getValue();
      }

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        const dataServiceId = this.isNew ? 'DTS_CMP_00104' : 'DTS_CMP_00105';
        http.request(this.contextPageId, dataServiceId, {
          data: this.objPortal,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.onClickNew();
          this.$emit('onClickSearch');
        });
      });
    },

    onClickDuplicationCheck() {
      let portalNewId = this.objPortal.portalId;// "MSG_"+this.frame0.selectedCodeValue.COD_MSG_RESO_TYPE.key;
      const dataParams = {
        portalNewId: portalNewId,
      };

      if (utils.isEmpty(this.objPortal.portalId)) {
        utils.messageBox('warning',
          utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PORTL_ID')),
          null,
          () => {
            this.$refs.textFieldPortalId.setFocus();
          });
        return false;
      }
      http.request(this.contextPageId, 'DTS_CMP_00107', {
        query: dataParams,
      }).then(res => {
        if (res.data > 0) {
          this.isIdDuplicationCheck = false;
          utils.messageBox('error', this.$t('MSG_ALT_IMG_RGST_ID'), null, () => { // 이미 등록된 ID입니다.
          this.$refs.textFieldPortalId.setFocus();
          });
        } else {
          this.isIdDuplicationCheck = true;
          this.cachePortalId = utils.clone(this.objPortal.portalId);
          utils.messageBox('success', this.$t('MSG_ALT_USE_PSBL_ID')); // 사용 가능한 ID입니다.
        }
      });

      return null;
    },
    inputValid() {
      if (this.objPortal.portalId) {
        this.objPortal.portalId = utils.toUpper(this.objPortal.portalId.replace(/[^a-z0-9_]/gi, ''));
      }
    },
  },
};
</script>

<style scoped>
</style>